import { useTooltipStyles } from '../ChartTooltipStyles';
import TimeAndStatus from './TimeAndStatus';
import MetricList from './MetricList';
import { MainMetric, ThresholdMetrics } from './MainMetricThreshold';

export default function WifiConnectTestTooltip({ chartDef, timeslice }) {
    const classes = useTooltipStyles();
    return (
        <div>
            <TimeAndStatus chartDef={chartDef} timeslice={timeslice} />
            <table className={classes.tooltipTable}>
                <tbody>
                    <MetricList chartDef={chartDef} timeslice={timeslice} />
                    <MainMetric timeslice={timeslice} mainMetric="avgtotal_connection_time" />
                </tbody>
            </table>
            <ThresholdMetrics timeslice={timeslice} degradedKey="th_m6_degraded" excesiveKey="th_m6_excessive" />
        </div>
    );
}
